import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import axios from 'axios';
const EmployeeContractModal = ({
  showModal,
  handleClose,
  editEmployeeContract,
  addEmployeeContract,
  EmployeeContractData,
  EmployeeContractId,
  EmployeeId
}) => {
  const [formData, setFormData] = useState({

    attachment: '',
    salary: '',
    contract_type: '',
    start_date: '',
    end_date: '',
    benefits: '',
    allowances: [],
    deductions: [],
  });

  const [deductions, setDeductions] = useState([]);
  const [overtimes, setOvertimes] = useState([]);
  const [errors, setErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);
  const [allowances, setAllowances] = useState([]);


  // ✅ Fetch Employees & Allowances
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("user-info"))?.token;
        const origin = localStorage.getItem("user-origin");

        const [alloRes, dedRes, otRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/allowances`, { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/deductions`, { headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin } }),
        ]);

        setAllowances(alloRes.data.data || []);
        setDeductions(dedRes.data.data || []);
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
      }
    };

    if (showModal) fetchData();
  }, [showModal]);

  useEffect(() => {
    if (showModal && !EmployeeContractData) {
      // Reset for "Add"
      setFormData({
        attachment: '',
        salary: '',
        contract_type: '',
        start_date: '',
        end_date: '',
        benefits: '',
        allowances: [],
        deductions:[],
      });
      setPreviewUrl(null);
    } else if (EmployeeContractData) {
      // Populate for "Edit"
      setFormData({
        salary: EmployeeContractData.salary || '',
        contract_type: EmployeeContractData.contract_type || '',
        start_date: EmployeeContractData.start_date || '',
        end_date: EmployeeContractData.end_date || '',
        benefits: EmployeeContractData.benefits || '',
        attachment: EmployeeContractData.attachment || '',
        allowances: EmployeeContractData.allowances || [],
        deductions: EmployeeContractData.deductions || [],
        employee_id: EmployeeId || '',
      });

      // ✅ build full file URL for preview
      if (EmployeeContractData.attachment) {
        const backendUrl = process.env.REACT_APP_BACKEND_URL; // e.g. http://127.0.0.1:8000
        setPreviewUrl(`${backendUrl}/storage/${EmployeeContractData.attachment}`);
      } else {
        setPreviewUrl(null);
      }
    }
  }, [EmployeeContractData, showModal]);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, attachment: file });
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  // Clear preview when user clicks X
  const handleClearPreview = () => {
    setPreviewUrl(null);
    setFormData({ ...formData, attachment: '' });
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.salary) newErrors.salary = 'Salary is required';
    if (!formData.contract_type) newErrors.contract_type = 'Contract Type is required';
    if (!formData.start_date) newErrors.start_date = 'Start Date is required';
    if (!formData.end_date) newErrors.end_date = 'End Date is required';
    return newErrors;
  };
  const handleDeductionChange = (id) => {
    setFormData((prev) => {
      const exists = prev.deductions.find(d => d.id === id);
      if (exists) {
        return { ...prev, deductions: prev.deductions.filter(d => d.id !== id) };
      }
      return { ...prev, deductions: [...prev.deductions, { id, amount: "" }] };
    });
  };

  const handleDeductionAmountChange = (id, amount) => {
    setFormData(prev => ({
      ...prev,
      deductions: prev.deductions.map(d => d.id === id ? { ...d, amount } : d)
    }));
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("employee_id", EmployeeId);
    formDataToSend.append("salary", formData.salary);
    formDataToSend.append("contract_type", formData.contract_type);
    formDataToSend.append("start_date", formData.start_date);
    formDataToSend.append("end_date", formData.end_date);
    formDataToSend.append("benefits", formData.benefits);

    // ✅ send allowances properly as array
    formData.allowances.forEach((a, index) => {
      formDataToSend.append(`allowances[${index}][id]`, a.id);
      formDataToSend.append(`allowances[${index}][amount]`, a.amount);
    });
    formData.deductions.forEach((d, index) => {
      formDataToSend.append(`deductions[${index}][id]`, d.id);
      formDataToSend.append(`deductions[${index}][amount]`, d.amount);
    });

    

    if (formData.attachment) {
      formDataToSend.append("attachment", formData.attachment);
    }

    let apierrors;
    if (EmployeeContractId) {
      apierrors = await editEmployeeContract(EmployeeContractId, formDataToSend);
    } else {
      apierrors = await addEmployeeContract(formDataToSend);
    }

    if (apierrors && Object.keys(apierrors).length > 0) {
      setErrors(apierrors);
    } else {
      setErrors({});
      setPreviewUrl(null);
      handleClose();
    }

    setLoading(false);
  };

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const validationErrors = validateForm();
  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //     setLoading(false);
  //     return;
  //   }

  //   // Prepare FormData for file upload
  //   const formDataToSend = new FormData();
  //   Object.keys(formData).forEach((key) => {
  //     formDataToSend.append(key, formData[key]);
  //   });

  //   let apierrors;
  //   if (EmployeeContractId) {
  //     apierrors = await editEmployeeContract(EmployeeContractId, formDataToSend);
  //   } else {
  //     apierrors = await addEmployeeContract(formDataToSend);
  //   }

  //   if (apierrors && Object.keys(apierrors).length > 0) {
  //     setErrors(apierrors);
  //     setLoading(false);
  //   } else {
  //     setErrors({});
  //     setPreviewUrl(null); // reset preview
  //     handleClose();
  //     setLoading(false);
  //   }
  // };

  const handleAllowanceChange = (id) => {
    setFormData((prev) => {
      const exists = prev.allowances.find((a) => a.id === id);
      if (exists) {
        return {
          ...prev,
          allowances: prev.allowances.filter((a) => a.id !== id),
        };
      }
      return {
        ...prev,
        allowances: [...prev.allowances, { id, amount: "" }],
      };
    });
  };

  const handleAllowanceAmountChange = (id, amount) => {
    setFormData((prev) => ({
      ...prev,
      allowances: prev.allowances.map((a) =>
        a.id === id ? { ...a, amount } : a
      ),
    }));
  };

  // ✅ Preview section now with Close (X) button
  const renderPreview = () => {
    if (!previewUrl) return null;
    return (
      <div className="mb-3 position-relative">
        <button
          type="button"
          onClick={handleClearPreview}
          className="btn-close position-absolute top-0 end-0 m-2"
          aria-label="Close"
        />
        {formData.attachment?.type?.includes("image") || previewUrl.endsWith(".jpg") || previewUrl.endsWith(".png") ? (
          <img
            src={previewUrl}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "8px" }}
          />
        ) : (
          <iframe
            src={previewUrl}
            title="File Preview"
            style={{ width: "100%", height: "200px", border: "1px solid #ddd", borderRadius: "8px" }}
          />
        )}
      </div>
    );
  };

  return (
    <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: "520px" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{EmployeeContractId ? "Edit Contract" : "Add Contract"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form onSubmit={handleSubmit}>


          {/* Salary */}
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Salary</Form.Label>
            <Form.Control
              type="number"
              name="salary"
              value={formData.salary}
              onChange={handleChange}
              className='form-control form-feild'
            />
          </Form.Group>

          {/* Contract Type */}
          {/* <Form.Group className="mb-3">
            <Form.Label>Contract Type</Form.Label>
            <Form.Control
              type="text"
              name="contract_type"
              value={formData.contract_type}
              onChange={handleChange}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Contract Type</Form.Label>
            <Form.Select
              name="contract_type"
              value={formData.contract_type}
              onChange={handleChange}
              className='form-control form-feild'
            >
              <option value="">-- Select Contract Type --</option>
              <option value="Limited">Limited Contract</option>
              <option value="Unlimited">Unlimited Contract</option>
              <option value="Part-Time">Part-Time Contract</option>
              <option value="Temporary">Temporary Contract</option>
              <option value="Internship">Internship / Training</option>
              <option value="Consultancy">Consultancy / Outsourced</option>
            </Form.Select>
          </Form.Group>


          {/* Dates */}
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className='form-font'>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  className='form-control form-feild'
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className='form-font'>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  className='form-control form-feild'
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Benefits */}
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Benefits</Form.Label>
            <Form.Control
              as="textarea"
              name="benefits"
              value={formData.benefits}
              onChange={handleChange}
              className='form-control form-feild'
            />

          </Form.Group>

          {/* Allowances */}
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Allowances</Form.Label>
            {allowances.map((a) => {
              const selected = formData.allowances?.find((x) => x.id === a.id);
              return (
                <div key={a.id} className="mb-2">
                  <Form.Check
                    type="checkbox"
                    label={a.name}
                    checked={!!selected}
                    onChange={() => handleAllowanceChange(a.id)}
                  />
                  {selected && (
                    <Form.Control
                      type="number"
                      placeholder="Enter amount"
                      value={selected.amount}
                      onChange={(e) =>
                        handleAllowanceAmountChange(a.id, e.target.value)
                      }
                      className="mt-1 form-control form-feild"
                    />
                  )}
                </div>
              );
            })}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Deductions</Form.Label>
            {deductions.map(d => {
              const selected = formData.deductions?.find(x => x.id === d.id);
              return (
                <div key={d.id} className="mb-2">
                  <Form.Check
                    type="checkbox"
                    label={d.name}
                    checked={!!selected}
                    onChange={() => handleDeductionChange(d.id)}
                  />
                  {selected && (
                    <Form.Control
                      type="number"
                      placeholder="Enter amount"
                      value={selected.amount}
                      onChange={e => handleDeductionAmountChange(d.id, e.target.value)}
                      className="mt-1 form-control form-feild"
                    />
                  )}
                </div>
              );
            })}
          </Form.Group>
          


          {/* Attachment */}
          <Form.Group className="mb-3">
            <Form.Label className='form-font'>Attachment</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} className='form-control form-feild' />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Close
            </Button>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};



export default EmployeeContractModal;
